import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext.jsx';
import Logo   from '../../components/common/Logo.jsx';
import Input  from '../../components/common/Input.jsx';
import Button from '../../components/common/Button.jsx';

export default function LoginPage() {
  const { login }   = useAuth();
  const navigate    = useNavigate();
  const [form, setForm]     = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [show2FA, setShow2FA] = useState(false);
  const [userId2FA, setUserId2FA] = useState(null);
  const [code2FA, setCode2FA] = useState('');

  const validate = () => {
    const e = {};
    if (!form.email)    e.email    = 'Email requis';
    if (!form.password) e.password = 'Mot de passe requis';
    setErrors(e);
    return !Object.keys(e).length;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const res = await login(form.email, form.password);
      if (res.requires2FA) {
        setUserId2FA(res.userId);
        setShow2FA(true);
      } else {
        toast.success('Connexion réussie !');
        navigate('/dashboard');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  if (show2FA) return (
    <AuthLayout>
      <h2 style={{ fontSize: 'var(--text-2xl)', fontWeight: 'var(--font-bold)', marginBottom: 8 }}>
        Vérification 2FA
      </h2>
      <p style={{ color: 'var(--elvyra-text-secondary)', marginBottom: 32, fontSize: 'var(--text-sm)' }}>
        Entrez le code de votre application d'authentification
      </p>
      <form onSubmit={async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
          const { default: api } = await import('../../services/api.js');
          const res = await api.post('/auth/2fa/verify', { userId: userId2FA, code: code2FA });
          const { data } = res.data;
          localStorage.setItem('elvyra_token',   data.accessToken);
          localStorage.setItem('elvyra_refresh', data.refreshToken);
          toast.success('Authentification réussie !');
          navigate('/dashboard');
        } catch (err) {
          toast.error(err.response?.data?.message || 'Code invalide');
        } finally {
          setLoading(false);
        }
      }}>
        <Input
          label="Code à 6 chiffres"
          value={code2FA}
          onChange={e => setCode2FA(e.target.value)}
          placeholder="000000"
          maxLength={6}
        />
        <Button type="submit" loading={loading} style={{ width: '100%', marginTop: 16 }}>
          Vérifier
        </Button>
      </form>
    </AuthLayout>
  );

  return (
    <AuthLayout>
      <h2 style={{ fontSize: 'var(--text-2xl)', fontWeight: 'var(--font-bold)', marginBottom: 8 }}>
        Connexion
      </h2>
      <p style={{ color: 'var(--elvyra-text-secondary)', marginBottom: 32, fontSize: 'var(--text-sm)' }}>
        Bienvenue sur ELVYRA — Surveillance intelligente
      </p>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <Input
          label="Email" type="email" required
          placeholder="vous@exemple.com"
          value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
          error={errors.email}
        />
        <Input
          label="Mot de passe" type="password" required
          placeholder="Votre mot de passe"
          value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
          error={errors.password}
        />
        <div style={{ textAlign: 'right' }}>
          <span style={{ fontSize: 'var(--text-xs)', color: 'var(--elvyra-accent)', cursor: 'pointer' }}>
            Mot de passe oublié ?
          </span>
        </div>
        <Button type="submit" loading={loading} style={{ width: '100%', marginTop: 8 }}>
          Se connecter
        </Button>
      </form>
      <p style={{ textAlign: 'center', marginTop: 24, fontSize: 'var(--text-sm)', color: 'var(--elvyra-text-secondary)' }}>
        Pas encore de compte ?{' '}
        <Link to="/register" style={{ color: 'var(--elvyra-accent)' }}>Créer un compte</Link>
      </p>
    </AuthLayout>
  );
}

function AuthLayout({ children }) {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--elvyra-bg)', padding: 'var(--space-4)',
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <Logo size="lg" showText={true} className="" />
          <p style={{ fontSize: 'var(--text-xs)', color: 'var(--elvyra-text-muted)', marginTop: 8 }}>
            DEKANI SOFTWARE
          </p>
        </div>
        <div className="card">{children}</div>
      </div>
    </div>
  );
}
